import axios from 'axios';
import { CREATE_STEP_ONE } from '../paths';

export const createStep1 = (data) => {
  const { title, description, duration, category, contentType, tags, zone } = data;
  const body = {
    title,
    desc: description,
    contentType: contentType?._id,
    duration,
    tags: tags.map(({ _id }) => _id),
    category: category?._id,
    zone: [zone?.value],
  };
  const response = axios.post(CREATE_STEP_ONE, body);
  return response;
};
